import React, { useEffect, useRef, useState } from 'react'
import Loader from 'react-loaders';
import AnimatedLetters from '../../Component/AnimatedLetters';
import "./contact.scss";
import Maintainance from '../../Component/Maintainance/Maintainance';
// importing emailjs
import emailjs from '@emailjs/browser';
const Contact = () => {
  // Maintainance Test
  const maintainance=false;
  const [letterClass, setLetterClass] = useState('text-animate');
  const refForm= useRef();
  useEffect(() => {
    setTimeout(() => {     setLetterClass('text-animate-hover')
       }, 3000)
    }, [])
  const sendEmail=(e)=>{
      e.preventDefault();
      emailjs.sendForm(
        'service_xsd5ksk', //service id
        'template_r1il59l', //template id
        refForm.current, //form data
        '3NCkwyiYTqZdeb39n' //public key token
      ).then((result) => {
        alert("Message sent successfully");
        window.location.reload(false)
        console.log(result.text);
    }, (error) => {

        alert("Failed to send message please try again later")      
        console.log(error.text);
    });


  }
  return (
    <>
      {maintainance ? (
          <Maintainance/>
        ):(
          <div className='container contact-page'>
          <div className="text-zone">
  
            <h1>
              <AnimatedLetters 
                  letterClass={letterClass}
                  strArray={['C','o','n','t','a','c','t',' ','m','e']}
                  idx={15} />
            </h1>
            <p>
              I am intrested in projects. So feel free to cotact me.
            </p>
            <div className="contact-form" >
              <form ref={refForm} onSubmit={sendEmail}>
                <ul>
                <li className="half">
                    <input placeholder="Name" type="text" name="name" required />
                  </li>
                  <li className="half">
                    <input
                      placeholder="Email"
                      type="email"
                      name="email"
                      required
                    />
                  </li>
                  <li>
                    <input
                      placeholder="Subject"
                      type="text"
                      name="subject"
                      required
                    />
                  </li>
                  <li>
                    <textarea
                      placeholder="Message"
                      name="message"
                      required
                    ></textarea>
                  </li>
                  <li>
                    <input type="submit" className="flat-button" value="SEND" />
                  </li>
                </ul>
              </form>
  
            </div>
          </div>
  
          </div>
        )}
    
    <Loader type='pacman'/>
    </>

  )
}

export default Contact